import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import { Field, Form, Formik } from "formik"
import PropTypes from "prop-types"
import { useContext } from "react"
import { useMutation, useQueryClient } from "react-query"
import { useHistory } from "react-router-dom"
import { removeClientKey } from "~/actions/clients"
import { updateClientKeys } from "~/actions/clients.js"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import AppContext from "~/contexts/App"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"
import serialize from "~/store/serialize"

import Box from "~/components/Common/Box"
import useStyles from "./styles"
const EditClientKeysDialog = () => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const { dialogs, closeDialog, openDialog, openSnackBar } =
    useContext(AppContext)
  const thisDialog = dialogs?.["EditClientKeysDialog"] || {}
  const { open = false, data } = thisDialog
  const openErrorSnackbar = useOpenErrorSnackbar()
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))
  const queryClient = useQueryClient()
  //close dialog set search value to empty string and
  //set component array state to the context state
  const handleClose = () => {
    closeDialog("EditClientKeysDialog", false)
  }

  //close the dialog
  const editKey = () => {
    handleClose()
  }

  const deleteClientKeyMutation = useMutation((data) =>
    removeClientKey(data.clientId.id, data.apiId.id, data.values),
  )
  const removeClientKeys = (clientId, apiId, values, actions) => {
    let data = {
      clientId: clientId,
      apiId: apiId,
      values: values,
    }
    deleteClientKeyMutation.mutate(data, {
      onSuccess: (res) => {
        serialize("client", res.client).then((serializedData) => {
          return queryClient.setQueryData("clients", (oldData) => {
            let newArray = []
            newArray = oldData.map((x) => {
              if (x.id !== serializedData.id) {
                return x
              } else {
                return serializedData
              }
            })

            return newArray
          })
        })
      },
      onError: (err) => {
        openErrorSnackbar(err, "Error Updating Client Keys")
      },
    })
  }
  // confirm delete function
  const confirmDelete = () => {
    if (data.apiKey !== null || data.apiKey !== undefined) {
      removeClientKeys(data.client, data.apiKey)
      closeDialog("confirmDialog", true)
    } else {
      closeDialog("confirmDialog", true)
    }
  }

  // open the dialog
  const openDeleteKeysDialog = (values) => {
    let data = {
      apiKey: values.apiKey,
      client: values.clientId,
      action: "edit",
      confirmDelete: confirmDelete,
    }
    openDialog("confirmDialog", data).then(() => {
      handleClose()
    })
  }

  // mutate data
  const updateClientMutation = useMutation((data) =>
    updateClientKeys(data.clientId, data.apiId, data.values),
  )

  //set client keys
  const setClientKeys = (clientId, apiId, values, actions) => {
    let data = {
      clientId: clientId,
      apiId: apiId,
      values: values,
    }

    updateClientMutation.mutate(data, {
      onSuccess: (res) => {
        serialize("client", res.client).then((serializedData) => {
          return queryClient.setQueryData("clients", (oldData) => {
            let newArray = []
            newArray = oldData.map((x) => {
              if (x.id !== serializedData.id) {
                return x
              } else {
                return serializedData
              }
            })

            return newArray
          })
        })
      },
      onError: (err) => {
        openErrorSnackbar(err, "Error Updating Client Keys")
      },
      onSettled: () => {
        actions.setSubmitting(false)
      },
    })
  }

  if (data !== undefined) {
    return (
      <Dialog
        classes={{ paperWidthSm: classes.dialogContainer }}
        open={open}
        fullScreen={smDown}
      >
        <DialogTitle className={classes.dialogTitle}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            className={classes.dialogTop}
          >
            <Typography variant="h2" className={classes.dialogTitle}>
              Edit API Token
            </Typography>
          </Box>
        </DialogTitle>
        <Formik
          initialValues={{
            name: `${data.apiKey.name}`,
            description: `${data.apiKey.description}`,
          }}
          onSubmit={(values, actions) => {
            setClientKeys(data.client.id, data.apiKey.id, values, actions)
          }}
        >
          {({ isSubmitting }) => (
            <div className={classes.dialogWrapper}>
              <Form className={classes.dialogContent}>
                <Typography variant="h4" className={classes.title}>
                  Name
                </Typography>
                <Field name="name" size="small">
                  {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                  }) => (
                    <div className={classes.inputWrapper}>
                      <input
                        className={classes.inputBoxes}
                        type="text"
                        placeholder="Name"
                        {...field}
                      />
                      {meta.touched && meta.error && (
                        <div className="error">{meta.error}</div>
                      )}
                    </div>
                  )}
                </Field>
                <Typography variant="h4" className={classes.title}>
                  Description
                </Typography>
                <Field name="description">
                  {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                  }) => (
                    <div className={classes.inputWrapper}>
                      <input
                        className={classes.inputBoxes}
                        type="text"
                        placeholder="Description"
                        {...field}
                      />
                      {meta.touched && meta.error && (
                        <div className="error">{meta.error}</div>
                      )}
                    </div>
                  )}
                </Field>
                <DialogActions
                  style={{
                    width: "100%",
                  }}
                  className={classes.actions}
                >
                  <Box display="flex" width="100%">
                    <Box
                      display="flex"
                      justifyContent="flex-start"
                      width="100%"
                      marginLeft="20px"
                      marginRight="20px"
                      className={classes.actionBox}
                    >
                      <Button
                        className={classes.remove}
                        onClick={() =>
                          openDeleteKeysDialog({
                            apiKey: data.apiKey.id,
                            clientId: data.client.id,
                          })
                        }
                      >
                        Delete
                      </Button>
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      width="100%"
                      marginLeft="20px"
                      marginRight="20px"
                      className={classes.actionBox}
                    >
                      <Box>
                        <Button
                          onClick={handleClose}
                          style={{ height: "40px", marginRight: "10px" }}
                        >
                          Cancel
                        </Button>
                        <LoaderButton
                          onClick={editKey}
                          working={isSubmitting}
                          classoverrides={{
                            wrapper: classes.button,
                            button: {
                              root: classes.buttonRoot,
                            },
                          }}
                          variant="contained"
                          color="secondary"
                          size="small"
                        >
                          Submit
                        </LoaderButton>
                      </Box>
                    </Box>
                  </Box>
                </DialogActions>
              </Form>
            </div>
          )}
        </Formik>
      </Dialog>
    )
  } else {
    return <></>
  }
}
EditClientKeysDialog.propTypes = {
  id: PropTypes.func,
  apiKeys: PropTypes.func,
}

export default EditClientKeysDialog
